import { useParams } from 'react-router-dom';

import { BoardLayout } from './ui/BoardLayout';

/** Доска: вкладки «Бэклог» и «Доска» под общей шапкой */
const BoardPage = () => {
  const { boardId = '' } = useParams();

  // key: при переключении доски — новые сторы, без остатков фильтров прошлой доски
  return <BoardLayout key={boardId} boardId={boardId} />;
};

export { BoardPage };
